import React, { Fragment } from 'react';
import { ArcaComponent } from '../../pages/ArcaComponent';

export class DateWrapper extends ArcaComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>

                <input
                    id='MyDate'
                    type='date'
                    value={this.props.referenceDate?.ToISODateString}
                    onChange={(e) => this.props.handleDateChange(e)} />
            </Fragment>
        )
    }
}